import AxiosInstance from "../Utils/axios/axiosConfig";

const getCompanyDetails = async () => {
    const response = await AxiosInstance.get("/companies/");
    if (!response.data.error) {
        return response.data;
    } else {
        return Promise.reject(response.message);
    }
};

const postCompany = async (body ={})=>{
    const response = await AxiosInstance.post(
    `/companies/`,
    body
    )
    if (!response.data.error) {
    return response.data;
    } else {
    return Promise.reject(response);
    }
}

const putCompany = async (body ={})=>{
    const response = await AxiosInstance.put(
    `/companies/`,
    body
    )
    if (!response.data.error) {
    return response.data;
    } else {
    return Promise.reject(response);
    }
}

export {
    getCompanyDetails,
    postCompany,
    putCompany
};